var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"password"},[_c('a',{staticClass:"link",on:{"click":_vm.resetPassword}},[_vm._v("Reset password")]),_c('div',{staticClass:"msg",domProps:{"textContent":_vm._s(_vm.message)}})])}
var staticRenderFns = []

export { render, staticRenderFns }